import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RootAccountComponent } from './root-account/root-account.component';
import { CompanyInfoComponent } from './company-info/company-info.component';
import { PersonalDataComponent } from './personal-data/personal-data.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { InvoiceDetailsComponent } from './invoice-details/invoice-details.component';
import { MyTicketsComponent } from './my-tickets/my-tickets.component';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { TransferredTicketsComponent } from './transferred-tickets/transferred-tickets.component';

const routes: Routes = [
  {
    path: '',
    component: RootAccountComponent,
    children: [
      {
        path: '',
        redirectTo: 'personal-data',
        pathMatch: 'full',
      },
      { path: 'personal-data', component: PersonalDataComponent },
      {
        path: 'company-info',
        component: CompanyInfoComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['creator'],
          },
        },
      },
      { path: 'invoices', component: InvoicesComponent },
      { path: 'invoice-details', component: InvoiceDetailsComponent },
      { path: 'my-tickets', component: MyTicketsComponent },
      { path: 'transferred-weapons', component: TransferredTicketsComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProfileRoutingModule {}
